<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-notebook-2"></i> 类别列表 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                    v-if="perData.allow_dele == 1"
                    >批量删除</el-button
                >
                <!-- <el-select v-model="query.address" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select> -->
                <el-input v-model="name" placeholder="搜索类别" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="float:right" type="primary" icon="el-icon-plus" v-if="perData.allow_add == 1" @click="handleAdd"
                    >添加类别</el-button
                >
            </div>
            <el-table
                :data="tableData"
                border
                stripe
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="type_no" label="编号" width="200" align="center"></el-table-column>
                <el-table-column prop="type_name" label="类别名称" align="center"></el-table-column>
                <el-table-column prop="type_ename" label="别名" align="center"></el-table-column>
                <el-table-column prop="status" label="是否显示" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" effect="dark" type="success">是</el-tag>
                        <el-tag v-if="scope.row.status == 0" effect="dark" type="danger">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250" align="center" v-if="perData.allow_edit == 1 || perData.allow_dele == 1">
                    <template slot-scope="scope">
                        <el-button type="primary" plain icon="el-icon-edit" @click="handleEdit(scope)" v-if="perData.allow_edit == 1"
                            >{{ $t('common.edit') }}</el-button
                        >
                        <el-button
                            type="danger"
                            plain
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope)"
                            v-if="perData.allow_dele == 1"
                            >{{ $t('common.delete') }}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="pageIndex"
                    :page-sizes="[5, 10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 添加类别 -->
        <el-dialog title="添加" :visible.sync="addData.isshow">
            <el-form label-width="100px">
                <el-form-item label="编号">
                    <label slot="label">编&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</label>
                    <el-input v-model="addData.data.type_no"></el-input>
                </el-form-item>
                <el-form-item label="类别名称">
                    <el-input v-model="addData.data.type_name" @blur="interName"></el-input>
                </el-form-item>
                <el-form-item label="别名">
                    <label slot="label">别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</label>
                    <el-input v-model="addData.data.type_ename"></el-input>
                </el-form-item>
                <el-form-item label="是否显示">
                    <el-radio v-model="addData.data.status" label="0">否</el-radio>
                    <el-radio v-model="addData.data.status" label="1">是</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addData.isshow = false">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑弹出框 -->
        <el-dialog :title="$t('common.edit')" :visible.sync="editData.isshow">
            <el-form label-width="100px">
                <el-form-item label="编号">
                    <label slot="label">编&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</label>
                    <el-input v-model="editData.data.type_no"></el-input>
                </el-form-item>
                <el-form-item label="类别名称">
                    <el-input v-model="editData.data.type_name" @blur="interName"></el-input>
                </el-form-item>
                <el-form-item label="别名">
                    <label slot="label">别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</label>
                    <el-input v-model="editData.data.type_ename"></el-input>
                </el-form-item>
                <el-form-item label="是否显示">
                    <el-radio v-model="editData.data.status" label="0">否</el-radio>
                    <el-radio v-model="editData.data.status" label="1">是</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editData.isshow = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchData } from '../../api/index';
import { apisetList, apisetDetail, apiaddSet, apimodifySet, apidelSet, apiCurrentPermisson } from '@/request/api';
export default {
    name: 'basetable',
    data() {
        return {
            name: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: '',
            pageTotal: 0,
            typeNo: '',
            selectList: [],
            editData: { isshow: false, scope: null, index: 0, data: {} },
            addData: { isshow: false, scope: null, index: 0, data: {} }
        };
    },
    created() {
        this.getData();
        this.getPermission();
    },
    activated() {
        this.getData();
        this.getPermission();
    },
    methods: {
        // 正则表达式  不能出现`'
        interName() {
            var pattern1 = /^[^\`]*$/;
            var pattern2 = /^[^\']*$/;
            if (this.addData.data.type_name == '') {
            } else if (!pattern2.test(this.addData.data.type_name) || !pattern1.test(this.addData.data.type_name)) {
                this.addData.data.type_name = '';
                this.$message.error("不能包含`或者'符号");
                return;
            }
            if (this.editData.data.type_name == '') {
            } else if (!pattern2.test(this.editData.data.type_name) || !pattern1.test(this.editData.data.type_name)) {
                this.editData.data.type_name = '';
                this.$message.error("不能包含`或者'符号");
                return;
            }
        },
        // 获取列表信息
        getData() {
            this.$load.show();
            apisetList({
                page: this.pageIndex,
                page_size: this.pageSize,
                keyword: this.name
            }).then(res => {
                this.$load.close();
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.page_total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '9'
            }).then(res => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addData.isshow = true;
            this.addData.data = {};
        },
        saveAdd() {
            let data = this.addData.data;
            apiaddSet(data).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '添加成功', type: 'success' });
                    this.addData.isshow = false;
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(scope) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apidelSet({
                        type_no: scope.row.type_no
                    }).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 多选删除操作----------------------------------------------------------------------------------------------------
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function(item, index, array) {
                arr.push(item.type_no);
            });
            this.selectList = arr;
        },
        delAllSelection() {
            if (this.selectList.length <= 0) {
                this.$message({ message: '请先选择需要操作的对象', type: 'error' });
                return;
            }
            this.$confirm('此操作将批量删除, 是否继续?', '批量删除提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            })
                .then(() => {
                    apidelSet({
                        type_no: this.selectList.join(',')
                    }).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                    // this.$message({ type: 'info',  message: '已取消删除' });
                });
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        handleEdit(scope) {
            this.editData.isshow = true;
            this.typeNo = scope.row.type_no;
            this.editData.data = {
                type_no: scope.row.type_no,
                type_name: scope.row.type_name,
                type_ename: scope.row.type_ename,
                status: scope.row.status.toString()
            };
            this.editData.row = scope.row;
            this.editData.index = scope.$index;
        },
        // 保存编辑
        saveEdit() {
            let data = this.editData.data;
            apimodifySet({
                type_no: this.typeNo,
                type_nos: data.type_no,
                type_name: data.type_name,
                type_ename: data.type_ename,
                status: data.status
            }).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '修改成功', type: 'success' });
                    this.editData.isshow = false;
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
.el-dialog {
    width: 40%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
